import { render, staticRenderFns } from "./genderChart.vue?vue&type=template&id=428f80ce"
import script from "./genderChart.vue?vue&type=script&lang=js"
export * from "./genderChart.vue?vue&type=script&lang=js"
import style0 from "./genderChart.vue?vue&type=style&index=0&id=428f80ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports